import React from 'react';
import Tooltip from '../../../../Components/Popup/Tooltip';
import useTranslation from '../../../../Hooks/useTranslation';
import LocalStorage from '../../../../Services/LocalStorage';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
// @ts-ignore
import styles from './LogoutButton.module.scss';

interface LogoutButtonProps {
	postLogoutUrl?: string;
}
const LogoutButton: React.FC<LogoutButtonProps> = ({ postLogoutUrl }) => {
	const { t } = useTranslation();

	const logout = () => {
		// @ts-ignore
		const keys = Object.keys(localStorage);
		console.log(keys);
		const filterKeys = Object.values(GRID_FILTER_KEYS);
		const keysToRemove = keys.filter(key =>
			filterKeys.some(filterKey => key.startsWith(filterKey)),
		);
		LocalStorage.removeKeys(keysToRemove);
		// @ts-ignore
		window.location.href = postLogoutUrl || '/odhlasit';
	};
	return (
		<Tooltip
			trigger={
				<div onClick={logout} className={styles.logoutButton}>
					<img src='/dist/icons/logout.svg' />
				</div>
			}
			position='bottom center'>
			{t('base.shared.logOut')}
		</Tooltip>
	);
};

export default LogoutButton;
